module.exports = __webpack_public_path__ + "media/images/icons/graph-ee86728043de31649010de5c2f5d43e3.svg";